import React, {useState, useEffect} from 'react'
import { Link, useParams } from 'react-router-dom';
import { faChevronRight, faChevronCircleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { API_URL } from '../../global/components/Constants';

const TopicDetailHeader = ({topic}) => {

    const [width, setWidth] = useState(window.innerWidth);
    const isMobile = width <= 768;

    const colors = topic.Theme.split("-");
    const bgColor = colors[0];
    const txtColor = colors[1];
    const extra1 = colors[2];
    const extra2 = colors[3];
    const extra3 = colors[4];

    const src=`${API_URL}/uploads/topic/${topic.Photo}`;

    function sliceBCrum(str){
        const maxLength = isMobile? 30: 60;
        if(str.length > maxLength){
            str = str.substring(0, (maxLength-3)) + " ...";
        }
        return str;
    }

    function desktopDisplay(){
        const styles = {
            header:{
                background: bgColor,
                marginBottom: 60,
                border: (bgColor == "#fff" || bgColor == "#ffffff")? '1px solid #dedede': 'none',
                borderRadius: 5
            },
            wrap:{
                display: 'flex',
            },
            wrapContent:{
                flex: 1,
                paddingTop: 30,
                paddingLeft: 20,
                paddingRight: 15,
                paddingBottom: 30,
            },
            wrapPhoto:{
                flex: 1,
                backgroundImage: `url(${src})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
            },
            breadcrum:{
                marginBottom: 20,
            },
            breadcrumLink:{
                color: extra2,
                fontSize: 14,
                textDecoration: 'none'
            },
            breadcrumTitle:{
                color: extra2,
                fontSize: 14
            },
            title:{
                color: txtColor,
                marginBottom: 20,
                fontSize: 38,
                fontWeight: 600,
                lineHeight: '50px'
            },
            desc:{
                color: txtColor,
                marginBottom: 20,
                fontSize: 16,
            },
            photo: {
                width: '100%',
            },
            btn:{
                background: '#fff',
                color: '#666',
                width: 140,
                padding: '5px 15px',
                fontSize: 13,
                fontWeight: 600,
                borderRadius: 30,
                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
            },
        }

        return (
            <section style={styles.header}>
                
                    <div style={styles.wrap}>
                        <div style={styles.wrapContent}>
                        <div className='container'>
                            <div style={styles.breadcrum}>
                                <Link to={"#"} style={styles.breadcrumLink}>{topic.CategoryName} / </Link>
                                <span style={styles.breadcrumTitle}>{sliceBCrum(topic.Title)}</span>
                            </div>
                            <h1 style={styles.title}>{topic.Title}</h1>
                            <div style={styles.desc}>{topic.Description}</div>
                            <Link to={`/topic/presentation-start/${topic.Slug}`} style={styles.btn} className='btn'>
                                <span>PRESENT &nbsp;&nbsp;</span>
                                <FontAwesomeIcon icon={faChevronRight} style={styles.btnIcon} />
                            </Link>
                        </div>
                        </div>
                        {(topic.Photo != "") && <div style={styles.wrapPhoto}></div>}
                    </div>
                
            </section>
        )
    }

    function mobileDisplay(){
        const styles = {
            header:{
                background: bgColor,
                borderBottom: (bgColor == "#fff" || bgColor == "#ffffff")? '1px solid #dedede': 'none'
            },
            container: {
                paddingTop:40,
                paddingBottom:30,
            },
            breadcrum:{
                paddingBottom: 20,
            },
            breadcrumLink:{
                color: extra2,
                fontSize: 13,
                textDecoration: 'none'
            },
            breadcrumTitle:{
                color: extra3,
                fontSize: 13
            },
            title:{
                paddingBottom: 30,
            },
            titleTxt:{
                color: txtColor,
                fontSize: 30,
                fontWeight: 600,
                lineHeight: '40px'
            },
            photo: {
                paddingBottom: 30,
            },
            photoImg: {
                width: '100%',
            },
            desc:{
                paddingBottom: 30
            },
            descTxt:{
                color: txtColor,
                fontSize: 16,
            },
        }

        return (
            <section style={styles.header}>
                <div style={styles.container}>

                <div style={styles.breadcrum}>
                    <div className='container'>
                        <Link to={"#"} style={styles.breadcrumLink}>{topic.CategoryName} / </Link>
                        <span style={styles.breadcrumTitle}>{sliceBCrum(topic.Title)}</span>
                    </div>
                </div>

                <div style={styles.title}>
                    <div className='container'>
                        <h1 style={styles.titleTxt}>{topic.Title}</h1>
                    </div>
                </div>

                {(topic.Photo != "") &&
                    <div style={styles.photo}>
                        <img src={`${API_URL}/uploads/topic/${topic.Photo}`} style={styles.photoImg} />
                    </div>
                }

                <div style={styles.desc}>
                    <div className='container'>
                        <div style={styles.descTxt}>{topic.Description}</div>
                    </div>
                </div>

            </div>   
            </section>
        )
    }

    return isMobile? mobileDisplay() : desktopDisplay()
}

export default TopicDetailHeader